var _path, _path2, _rect, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPdf(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.8999 4.8005C6.8999 4.19299 7.39239 3.7005 7.9999 3.7005H18.9928L25.0999 9.80761V27.2005C25.0999 27.808 24.6074 28.3005 23.9999 28.3005H7.9999C7.39239 28.3005 6.8999 27.808 6.8999 27.2005V4.8005Z",
    fill: "#F4FBFF",
    stroke: "#75C7FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2002 3.20001L25.6002 9.60001H20.8002C19.9165 9.60001 19.2002 8.88367 19.2002 8.00001V3.20001Z",
    fill: "#75C7FF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 13.3333,
    width: 20.6667,
    height: 11.3333,
    rx: 2,
    fill: "#D04738"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.77588 22H5.87188V19.824H7.13588C8.36788 19.824 9.19188 19.008 9.19188 17.912C9.19188 16.8 8.36788 16 7.13588 16H4.77588V22ZM7.11988 16.984C7.71988 16.984 8.10388 17.336 8.10388 17.912C8.10388 18.48 7.71988 18.84 7.11988 18.84H5.87188V16.984H7.11988Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3228 22H12.2668C14.0668 22 15.2668 20.72 15.2668 18.984C15.2668 17.272 14.0668 16 12.2668 16H10.3228V22ZM12.2668 17.008C13.3868 17.008 14.1308 17.8 14.1308 18.992C14.1308 20.192 13.3868 20.992 12.2668 20.992H11.4188V17.008H12.2668Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4478 22H17.5438V19.464H19.5358V18.488H17.5438V16.984H20.2398V16H16.4478V22Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.4e97ea5710bb1872162aa66c03bf7229.svg";
export { ForwardRef as ReactComponent };